export const INVITE_FORM_DATA = 'INVITE_FORM_DATA';

export const INVITE_STATUS_WAIT = 0; // 未申请
export const INVITE_STATUS_WAITTING = 1; // 申请中
export const INVITE_STATUS_SUCCESS = 2; // 已通过
export const INVITE_STATUS_ACTIVE = 3; // 已激活
export const INVITE_STATUS_FAIL = 9; // 拒绝

export const INVITE_BTN_TEXT_MAP = {
  [INVITE_STATUS_WAIT]: '提交申请',
  [INVITE_STATUS_WAITTING]: '已提交申请，请耐心等待',
  [INVITE_STATUS_SUCCESS]: '申请成功',
  [INVITE_STATUS_ACTIVE]: '已激活',
  [INVITE_STATUS_FAIL]: '已提交申请，请耐心等待',
}

export const formList = [
  {
    label: '手机号码',
    name: 'mobile',
    disabled: true,
    rules: [{ required: true, message: '请绑定手机号码' }],
    placeholder: '请绑定手机号码',
  },
  {
    label: '您希望深度研究智能体为您执行哪些任务？',
    name: 'user_need',
    rules: [
      {
        required: true,
        message: '请输入您希望深度研究智能体为您执行哪些任务？',
      },
    ],
    placeholder:
      '想让深度研究智能体大显身手？快告诉我们您最想攻克哪些难题！现诚邀您分享具体痛点及期望完成的任务，详尽的需求描述将助力我们为您量身打造高适配性解决方案。（必填)',
    textarea: true,
  },
  {
    label: '职业',
    name: 'job',
    placeholder:
      '请分享您所在的行业、职位、公司名称，或是其他与您职业相关的信息',
  },
  {
    label: '工作邮箱',
    name: 'email',
    placeholder: '请输入您的工作邮箱',
  },
  {
    label: '社交媒体主页',
    name: 'social_media',
    textarea: true,
    placeholder:
      '请分享您在微博、小红书、抖音等社交媒体上的个人主页链接或账号，方便我们更全面地了解您~',
  },
];